import {
  closePingfloCompanion,
  OPEN_PLAYER_NEW_SESSION_EVENT,
  OPEN_PRESENCE_REPORT_EVENT,
  OPEN_ADMIN_SIDEBAR_EVENT,
  OPEN_PROFILE_SMART_EVENT,
} from "./tourEvents";
import { OPEN_AI_COACH_EVENT } from "../components/HomeDailyFocus";
import { writeActiveHomeRole } from "../utils/homeRole";

export const SAFE_ACTION_TYPES = new Set([
  "navigate",
  "openPanel",
  "openCompanion",
  "closeCompanion",
  "setHomeRole",
]);

const SAFE_PANELS = new Set([
  "addSession",
  "playerNewSession",
  "companion",
  "presenceReport",
  "adminSidebar",
  "profileSmart",
]);

export function isSafeTourAction(action) {
  if (!action || typeof action !== "object") return false;
  if (!SAFE_ACTION_TYPES.has(action.type)) return false;
  if (action.type === "navigate") {
    const to = String(action.to || "");
    return to.startsWith("/") && !to.startsWith("//");
  }
  if (action.type === "openPanel") return SAFE_PANELS.has(action.panel);
  if (action.type === "setHomeRole") {
    return ["player", "coach", "admin", "parent", "monitor"].includes(action.role);
  }
  return true;
}

export function executeTourAction(action, { navigate } = {}) {
  if (!isSafeTourAction(action)) return false;
  if (action.type === "navigate" && typeof navigate === "function") {
    navigate(action.to);
    return true;
  }
  if (action.type === "closeCompanion") {
    closePingfloCompanion();
    return true;
  }
  if (action.type === "openCompanion" || (action.type === "openPanel" && action.panel === "companion")) {
    window.dispatchEvent(
      new CustomEvent(OPEN_AI_COACH_EVENT, {
        detail: { home_role: action.homeRole || undefined, seedVisible: false },
      })
    );
    return true;
  }
  if (action.type === "openPanel" && action.panel === "addSession") {
    window.dispatchEvent(
      new CustomEvent("openAddSessionDialog", {
        detail: {},
        bubbles: true,
        cancelable: true,
      })
    );
    return true;
  }
  if (action.type === "openPanel" && action.panel === "playerNewSession") {
    window.dispatchEvent(new CustomEvent(OPEN_PLAYER_NEW_SESSION_EVENT));
    return true;
  }
  if (action.type === "openPanel" && action.panel === "presenceReport") {
    window.dispatchEvent(
      new CustomEvent(OPEN_PRESENCE_REPORT_EVENT, {
        detail: { open: action.open !== false },
      })
    );
    return true;
  }
  if (action.type === "openPanel" && action.panel === "adminSidebar") {
    window.dispatchEvent(
      new CustomEvent(OPEN_ADMIN_SIDEBAR_EVENT, { detail: { open: action.open !== false } })
    );
    return true;
  }
  if (action.type === "openPanel" && action.panel === "profileSmart") {
    if (typeof navigate === "function") navigate("/profile?tab=smart");
    window.dispatchEvent(new CustomEvent(OPEN_PROFILE_SMART_EVENT));
    return true;
  }
  if (action.type === "setHomeRole") {
    writeActiveHomeRole(action.role);
    return true;
  }
  return false;
}
